// Scroll-spy rule shared by the Setup page and its test.
//
// The Setup page tells the live preview which section the operator is looking at
// by watching scroll position: pick the last section whose top has crossed a
// line near the top of the viewport. A long page also needs a "bottom snap" —
// the final section can never scroll its top past the line (the page ends
// first), so once scrolled to the very bottom we force the last section.
//
// The catch the bottom snap created: on a mostly-empty setup every section is
// short, so the whole page fits in the viewport and never scrolls. A page that
// doesn't scroll always reads as "at the bottom", which pinned the preview to
// the last section (Thank-you & links) the moment it loaded — and no amount of
// scrolling could move it, because there was nothing to scroll. So the snap only
// applies when the page is actually scrollable.

const BOTTOM_EPSILON = 8;

// sections: ordered [{ id, top }] where `top` is the section's
// getBoundingClientRect().top (relative to the viewport). Only sections actually
// present in the DOM should be passed — Branding/CustomLink render conditionally,
// so the "last section" for the bottom snap must be the last *rendered* one.
export function pickActiveSection({ sections, line, scrollTop, viewportHeight, scrollHeight }) {
  if (!sections || !sections.length) return null;

  let active = sections[0].id;
  sections.forEach(({ id, top }) => {
    if (top <= line) active = id;
  });

  const scrollable = scrollHeight - viewportHeight > BOTTOM_EPSILON;
  const atBottom = scrollHeight - (scrollTop + viewportHeight) < BOTTOM_EPSILON;
  if (scrollable && atBottom) {
    active = sections[sections.length - 1].id;
  }

  return active;
}
